import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
} from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

const MenuItemStyled = styled(MenuItem)({
  color: '#58585A',
});

interface Props {
  label: string;
  value: string;
  setSelectedValue: (value: string) => void;
  data: string[];
}

const Selector: FC<Props> = observer(props => {
  const { data, label, setSelectedValue, value } = props;

  const handleChange = (event: SelectChangeEvent) => {
    setSelectedValue(event.target.value as string);
  };

  if (!data) return null;

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel>{label}</InputLabel>
        <Select
          value={value}
          label={label}
          onChange={handleChange}
          sx={{ color: '#58585A' }}
        >
          {data?.map(item => (
            <MenuItemStyled key={item} value={item}>
              {item}
            </MenuItemStyled>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
});

export default Selector;
